import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';

import styles from './base-text.less';

interface TextDynamicProps extends HTMLAttributes<HTMLDivElement> {
    /** На всю ширину */
    stretched?: boolean;
}

export const TextDynamic: FC<PropsWithChildren<TextDynamicProps>> = ({ stretched, ...props }) => {
    const forceDisabled = useDisabled();

    return (
        <div
            className={classnames([styles.textDynamic, stretched && styles.textDynamicStretched], {
                [styles.textDynamicDisabled]: forceDisabled,
            })}
            {...props}
        />
    );
};
